import request from '@/utils/request'

// 查询预制项目历史事件
export function findAgentPreOrderItemEvents(params) {
  return request({
    url: `/agent_pre_order_item_events`,
    method: 'get',
    params: params
  })
}
